import React from 'react';
import { PropTypes } from 'prop-types';

const Error = ({ className, t }) => (
  <div className={className}>
    <div className="text">{t('no_position')}</div>
  </div>
);

Error.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

Error.defaultProps = {
  className: '',
  t: (t) => t,
};

export default Error;
